"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeAPISiteApprove = exports.getAPISites = exports.getAPISite = void 0;
require("core-js/modules/es.promise.js");
var _paulCorePackage = require("paul-core-package");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
const {
  getDefaultHeaders
} = _paulCorePackage.helpers;
const getAPISites = async _ref => {
  let {
    prefUrl,
    token
  } = _ref;
  return fetch("".concat(prefUrl, "/sites/paul_live"), _objectSpread(_objectSpread({}, getDefaultHeaders(token)), {}, {
    method: 'POST'
  }));
};
exports.getAPISites = getAPISites;
const getAPISite = async _ref2 => {
  let {
    prefUrl,
    token,
    siteId
  } = _ref2;
  return fetch("".concat(prefUrl, "/sites/paul_live/").concat(siteId), _objectSpread(_objectSpread({}, getDefaultHeaders(token)), {}, {
    method: 'POST'
  }));
};
exports.getAPISite = getAPISite;
const makeAPISiteApprove = async _ref3 => {
  let {
    prefUrl,
    token,
    siteId
  } = _ref3;
  return fetch("".concat(prefUrl, "/sites/paul_live/approve/").concat(siteId), _objectSpread(_objectSpread({}, getDefaultHeaders(token)), {}, {
    method: 'POST'
  }));
};
exports.makeAPISiteApprove = makeAPISiteApprove;